module.exports = __webpack_public_path__ + "static/media/1_5an.35ffc1d6.png";